import { Controller } from "stimulus";

export default class extends Controller {
  static values = { closeUrl: String };

  connect() {
    // Close when clicking anywhere outside the panel
    this._handleOutsideCapture = (e) => {
      const clickedInside = this.element.contains(e.target);
      if (!clickedInside) {
        setTimeout(() => this.closeFrame(), 0);
      }
    };
    window.addEventListener("pointerdown", this._handleOutsideCapture, true);
  }

  disconnect() {
    if (this._handleOutsideCapture) {
      window.removeEventListener("pointerdown", this._handleOutsideCapture, true);
    }
  }

  closeFrame = () => {
    const url = this.closeUrlValue;
    if (window.Turbo && typeof window.Turbo.visit === "function") {
      window.Turbo.visit(url, { frame: "search-results" });
    }
  }
}